import React from "react";
import { StyledBoldText } from "./styles";
import PropTypes from 'prop-types'

export const DocumentationBoldText =({text, boldText}) => {
   let newSentence = [];
   let lastIndexTracker = 0;
   
   //loop through each text to bold
   boldText.forEach(textToBold=>{
    //get index of text to bold from string text
    //lastIndexTracker keeps track of what index to start at 
    let index = text.indexOf(textToBold,lastIndexTracker);

    while (index !== -1) {
        if(index > lastIndexTracker) {
            //Add any text that is before textToBold
            newSentence.push(text.substring(lastIndexTracker,index))
        }
        newSentence.push(<StyledBoldText key={index}>{textToBold}</StyledBoldText>)

        //Set lastIndexTracker to be the index after textToBold text is added
        lastIndexTracker = index + textToBold.length;
        //Sets index to -1 (does not exist) since lastIndexTracker is now updated to the index after textToBold is added
        index = text.indexOf(textToBold,lastIndexTracker)
    }
   });
   //If there is any text left after textToBold, add it 
   if(lastIndexTracker < text.length) {
    newSentence.push(text.substring(lastIndexTracker))
   }
   
   return newSentence;
}

DocumentationBoldText.propTypes = {
    text: PropTypes.string.isRequired,
    boldText: PropTypes.array.isRequired,
}

export default DocumentationBoldText;